<template>
  <div>
    <h1>
      Le jeu trop classe
      <em>Châteaux</em>
    </h1>
    <p>
      Nous tenions avant toute chose à vous présenter nos excuses pour "le jeu trop classe" de la
      semaine dernière dans lequel nous vous avons proposé de classer des photos de selles humaines
      selon l'échelle de Bristol. Vous avez été nombreux à nous alerter sur l'aspect choquant d'un
      tel classement et nous ne pouvons que reconnaitre notre erreur. Retour donc, cette semaine, à
      un thème beaucoup plus familial :
    </p>
    <p class="center-text">
      <b>
        Classez ces châteaux en fonction de leur date d'inscription au patrimoine de l'UNESCO de la
        plus ancienne à la plus récente !
      </b>
    </p>
    <div class="center-text full-width">
      <img src="../../../assets/NewYear/castle-S.png" class="castle" />
      <img src="../../../assets/NewYear/castle-L.png" class="castle" />
      <img src="../../../assets/NewYear/castle-V.png" class="castle" />
      <img src="../../../assets/NewYear/castle-E.png" class="castle" />
      <img src="../../../assets/NewYear/castle-I.png" class="castle" />
    </div>
    <div class="hints">
      <div v-for="(hint, index) in reduceList" :key="index">
        <button
          :class="getClass(hint, index)"
          @click="display(hint.id)"
          :disabled="getClass(hint, index) === 'inactive' "
        >💡 #{{index + 1}}</button>
      </div>
    </div>
    <div v-for="(hint, index) in reduceList" :key="index">
      <hint
        v-if="hint.display"
        :content="hint.content"
        :index="index"
        :read="hint.read"
        @close="closeHints()"
        @continue="increment(hint.id)"
      />
    </div>
  </div>
</template>

<script>
import Hint from "../../shared/Hint";

export default {
  props: {
    hintList: Array
  },
  components: {
    Hint
  },
  data() {
    return {
      hints: this.hintList,
      reduceList: this.hintList.filter(h => h.vue === "castle")
    };
  },
  methods: {
    closeHints() {
      this.hints.forEach(h => {
        h.display = false;
      });
    },
    display(id) {
      this.closeHints();
      this.hints.find(h => h.id === id).display = true;
    },
    getClass(hint, index) {
      if (this.hints.find(h => h.id === hint.id).read) return "read";
      if (index === 0) return "active";
      if (this.reduceList[index - 1].read) return "active";
      return "inactive";
    },
    increment(id) {
      this.hints.find(h => h.id === id).read = true;
      this.$emit("updateHints", this.hints);
      this.$emit("incrementCounter");
    }
  }
};
</script>

<style scoped>
h1 {
  font-family: "Playfair Display", serif;
  font-weight: bold;
  color: rgb(35, 35, 35);
  font-size: 300%;
  margin-top: 0;
  border-bottom: double rgb(35, 35, 35);
  width: 100%;
}
p,
a {
  color: rgb(35, 35, 35);
  font-family: "Playfair Display", serif;
  font-size: 16px;
}
em {
  font-size: 40%;
  color: #ebc134;
}
.full-width {
  width: 100%;
}
.center-text {
  text-align: center;
}
.castle {
  max-height: 190px;
  margin: 1%;
}
.hints {
  position: absolute;
  bottom: -3%;
  width: 82%;
  display: flex;
  justify-content: space-evenly;
}
.hints button {
  font-family: "IBM Plex Mono", monospace;
  font-weight: bold;
  border: none;
  border-radius: 3px;
}
.hints button:focus {
  outline: none;
}
.inactive {
  cursor: not-allowed;
  background: #ce322c;
  color: rgb(235, 235, 235);
}
.active {
  cursor: pointer;
  background: #faa806;
  color: rgb(235, 235, 235);
}
.read {
  cursor: pointer;
  background: #01593b;
  color: rgb(235, 235, 235);
}
</style>
